module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notification-components/notification-list/notification-list.component.css
// module id = ./src/app/notification-components/notification-list/notification-list.component.css
// module chunks = main